<template>
  <div class="index">
    <div class="information-container">
      <div class="centered add-document">
        <span class="button-wrapper link" @click="addDeponentsData()">
          <a class="button is-info">+</a> Добавить документ
        </span>
      </div>
      <div class="documents to-deponents" v-if="documents.length">
        <table>
          <thead>
            <tr>
              <td>Документ</td>
              <td>Дата публикации</td>
              <td>Дата события</td>
              <td>Событие</td>
              <td>Эмитент <br> Номер ценной бумаги</td>
              <td>Дата отсчечения <br> реестра</td>
              <td>Дата фиксации</td>
              <td></td>
            </tr>
          </thead>
          <DeponentsItem v-for="document in documentsData" :key="document.id" :data="document"/>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DeponentsItem from 'components/Information/ToDeponentsItem'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'

export default {
  name: 'InformationDocuments',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['documents']),
    documentsData () {
      return deepcopy(this.documents)
    }
  },
  created () {
    this.getDeponentsData()
  },
  methods: {
    ...mapActions(['getDeponentsData', 'addDeponentsData'])
  },
  components: { DeponentsItem }
}
</script>

<style scoped>
.information-container {
  background: #eee;
  padding: 25px 0 60px;
  margin: 15px auto 0;
}
.documents {
  background: white;
  padding: 35px 40px 40px;
  max-width: 1368px;
  margin: 0 auto;
  min-width: 1350px;;
}
.documents thead {
  color: darkgray;
  font-size: 14px;
}
.documents thead :not(:first-child) {
  padding-left: 10px;
}
.add-document {
  margin: 0 0 22px;
}
</style>



// WEBPACK FOOTER //
// ToDeponents.vue?5fe35a26